module.exports = __webpack_public_path__ + "img/inactiveuparrow.43e7ac50.svg";